import company_data from '../../../static/json/driverlessCompany.json'
import driverless_box from "../components/Driverless_box"
export default {
  name: 'Driverless',
  data () {
    return {
      company_info: {},
      screenWidth: document.documentElement.clientWidth
    }
  },
  methods: {

  },
  created () {
    for (let attr in company_data) {
      this.company_info[attr] = company_data[attr]
    }
  },
  mounted() {
    var self = this;
    window.onresize = function () { // 定义窗口大小变更通知事件
      self.screenWidth = document.documentElement.clientWidth
      self.screenHeight = document.documentElement.clientHeight
    }
  },
  watch: {
    'screenWidth':function (val){
      if(Number(val) >= 1200){
        this.$refs.unmanded.style.transform = 'scale(' + Number(val) / 1920 + ')'
        this.$refs.unmanded.style.marginLeft = (Number(val) - 1920) / 3 + 20 + 'px'
        this.$refs.unmanded.style.marginTop = (Number(val) - 1920) / 4 + 20 + 'px'
      }
    }
  },
  components: {
    "driverless-box": driverless_box
  }
}



// WEBPACK FOOTER //
// ./src/supplychain/js/driverless.js